import React, { useState, useMemo, useEffect } from 'react'
import { NavLink, Link } from 'react-router-dom'
import { useHistory } from 'react-router'
import { Api } from '../../../useFetch'
import { navigationLinks } from './NavigationLinks'

const Navigation = props => {

    const [campsNav, setCampsNav] = Api({
        method: 'get',
        url: '/api/camps-type/navigation'
    })
    const [burgernav, setburgernav] = useState(false)
    const [nav, setNav] = useState(navigationLinks)

    let history = useHistory()

    useEffect(() => {
        document.body.classList = ''
        setCampsNav()
    }, [])

    useEffect(() => {
        if (campsNav.data) {
            const navigation = _.cloneDeep(nav)
            let camps = navigation.find(obj => obj.name === 'Obozy')
            const index = navigation.findIndex(obj => obj.name === 'Obozy')

            camps = _.cloneDeep(camps)

            campsNav.data.forEach(item => {
                if (item.active) {
                    camps.submenu.push({
                        name: item.title,
                        url: `/obozy/${item.identifier}`
                    })
                }
            })
            navigation[index] = camps

            setNav(navigation)
        }
    }, [campsNav])

    function handleClick() {
        setburgernav(!burgernav)
        !burgernav ? document.body.classList = 'noscroll' : document.body.classList = ''
    };

    function toggleSubmenuHandler(e, id) {
        e.preventDefault()
        e.stopPropagation()
        const newNav = _.cloneDeep(nav)
        newNav[id].expanded = !newNav[id].expanded
        setNav(newNav)
    };

    function closeMenu() {
        setburgernav(false)
        document.body.classList = ''
    }

    const slideToSection = ref => {
        const url = ref.replace('#', '')
        const el = document.getElementById(url)
        const position = el.getBoundingClientRect().top + 50 + document.documentElement.scrollTop

        closeMenu()

        window.scroll({
            top: position,
            behavior: 'smooth',
            passive: true
        })
    }

    function goToSection(ref, loc) {

        if (loc !== location.pathname) {
            history.push(loc)
            closeMenu()
            return setTimeout(() => slideToSection(ref), 1000)
        }

        slideToSection(ref)
    };

    const checkLocation = (url) => {
        const URL = url.replace('/', '')
        const pathParts = location.pathname.split('/')
        return pathParts.some(part => part === URL)
    }

    const burgerNav = (
        <button className={'burger-nav' + (burgernav ? ' active' : '')} onClick={handleClick} aria-expanded={burgernav} aria-label={burgernav ? 'Zamknij menu' : 'Otwórz menu'}>
            <span className="burger-nav__element burger-nav__top"></span>
            <span className="burger-nav__element burger-nav__middle"></span>
            <span className="burger-nav__element burger-nav__bottom"></span>
            <span className="burger-nav__element-text">Menu</span>
        </button>
    )

    const navigation = (
        <ul className={burgernav ? 'active site-navigation__menu' : 'site-navigation__menu'}>
            {nav.map((link, id) => {
                return (
                    <li className="site-navigation__menulink" key={id}>
                        <NavLink onClick={closeMenu} className={
                            'site-navigation__link' + (link.expanded ? ' expanded ' : '') + (checkLocation(link.url) && link.url !== '/' ? ' active' : '')
                        } to={link.url} exact><span className="site-navigation__menulink-name">{link.name}</span>

                            {link.submenu ? <span className="submenu-trigger icon icon-angle-down" onClick={(e) => toggleSubmenuHandler(e, id)} role="button" tabIndex="0" aria-label={`Rozwiń podmenu ${link.name}`}></span> : null}
                        </NavLink>
                        {link.submenu ? (
                            <div className="submenu">
                                <div className="container">
                                    <ul className="px-0">
                                        {link.submenu.map((item, id) => {
                                            return (
                                                <li key={id}>
                                                    <Link onClick={link.isInnerMenu ? () => goToSection(item.url, link.url) : closeMenu} className="site-navigation__link" to={link.isInnerMenu ? `${link.url}${item.url}` : item.url}>{item.name}</Link>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                        ) : null}
                    </li>
                )
            })}
        </ul>
    )

    return (
        <>
            <nav className={burgernav ? 'site-navigation active' : 'site-navigation'}>
                {useMemo(() => burgerNav, [burgernav])}
                <div className="container">
                    {navigation}
                </div>
            </nav>
        </>
    )
}

export default Navigation
